export class CustomerName {
    public customerNameId: number;
    public customerNumberId: number;
    public customerNameTypeId: number;
    public customerIndividualNameSuffixTypeId: number;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public organizationName: string;
    public displayName: string;
    public isVerified: boolean;
    public inactivate: boolean;
}
